import MUIButtom, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/system';

const DefaultButtom = (props: ButtonProps) => {
  return <MUIButtom variant="contained" size="medium" {...props} />;
};

export const Button = styled(DefaultButtom)(({ theme }) => ({}));
